import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'

import { PROPERTY_TYPE_PLURAL, IS_PROPERTY } from 'Config/config'
import { BUTTON_HOVER, TERTIARY_COLOR } from '@CSSVars/colors'

import SvgIcon from 'Components/SvgIcon'
import OfferTabV3 from 'Layout/OfferTabV3'

import { Collapsible } from 'Components'
// import AppLink from 'Components/AppLink'
import { RangeSlider } from 'Components/Form'
import AppLineChart from './AppLineChart'
import { getDataIndexOnScroll } from './utils'

// import css from './styles.js'
import {
  outerCollapseLabelCss, printCollapsibleContentCss, _RowContainer,
  _AreaOfferContainer, _DesktopVisitButtonContainer, _MobileVisitButtonContainer,
  _VisitButton, _SummaryContainer, _RangeSliderPositionContainer,
  _RangeSliderContainer, sliderCollapseLabelCss, sliderCollapseContentCss,
  sliderCollapseInputCss, sliderContentInnerCss, _ChartWrapper, _ChartSummaryBlock,
  simpleChartCollapseContentCss, _ChartSeparatorLine, _OfferContainer,
} from './styles'

let areaPrefix = 'all-types-all-bed-types-'
if(IS_PROPERTY) areaPrefix = 'all-home-types-all-bed-types-'

// @todo use prefix from backend
export const STAT_TARGET_KEYS = {
  BUILDING: 'all-avg_psf',
  BUILDING_PSF_CHANGE: 'all-avg_psf_change',
  BUILDING_PSF_COUNT: 'all-count_psf',
  // area
  AREA: `${areaPrefix}avg_psf`,
  AREA_PSF_COUNT: `${areaPrefix}count_psf`,
  AREA_PSF_CHANGE: `${areaPrefix}avg_psf_change`,
  // maint
  BUILDING_MAINT: 'building_maintenance',
  AREA_MAINT: 'area_maintenance',
}

/**
 * merging area stats and building stats
 * if data is not formatted in a way Rechart want, it creates zigzag line
 * if backend merge data this code is not necessary.
 */
const mergeAreaBuilding = (offerKey, areaChart, buildingChart) => {
  const offerType = offerKey === 'Rent' ? 'leased' : 'sold'
  const areaStatData = areaChart && areaChart.data ? areaChart.data : null
  const buildingStatData =
    buildingChart && buildingChart.data ? buildingChart.data : null
  let years = []
  let areaOfferData = {}
  let buildingOfferData = {}
  if(areaStatData) {
    areaOfferData =
      areaStatData[offerType] && areaStatData[offerType].Y
        ? areaStatData[offerType].Y
        : {}
    years = Object.keys(areaOfferData)
  }
  if(buildingStatData) {
    buildingOfferData =
      buildingStatData[offerType] && buildingStatData[offerType].Y
        ? buildingStatData[offerType].Y
        : {}
    years = R.uniq([...years, ...Object.keys(buildingOfferData)]).sort()
  }
  const mergedChartData = []
  const mergedChartDataLookup = {}
  years?.forEach((year, index) => {
    mergedChartDataLookup[year] = index
    if(areaOfferData[year] && buildingOfferData[year]) {
      mergedChartData.push({
        ...areaOfferData[year],
        ...buildingOfferData[year],
        name: year,
      })
    } else if(areaOfferData[year]) {
      mergedChartData.push({
        ...areaOfferData[year],
        name: year,
      })
    } else if(buildingOfferData[year]) {
      mergedChartData.push({
        ...buildingOfferData[year],
        name: year,
      })
    }
  })
  const periodRangeMin = Number(years[0])
  const periodRangeMax = years.length ? Number(years[years.length - 1]) : 0
  return {
    mergedChartDataLookup,
    mergedChartData,
    periodRangeMin,
    periodRangeMax,
    currentPeriodMin: periodRangeMin,
    currentPeriodMax: periodRangeMax,
  }
}

const clickedPointUpdated = (label, mergedChartData, mergedChartDataLookup) => {
  const currentData = mergedChartData[mergedChartDataLookup[label]]
  if(!currentData) return {}
  const currentYearData = {
    currentBuildingPsf: currentData[STAT_TARGET_KEYS.BUILDING],
    currentBuildingPsfChange: currentData[STAT_TARGET_KEYS.BUILDING_PSF_CHANGE],
    currentBuildingPsfCount: currentData[STAT_TARGET_KEYS.BUILDING_PSF_COUNT],
    currentAreaPsf: currentData[STAT_TARGET_KEYS.AREA],
    currentAreaPsfChange: currentData[STAT_TARGET_KEYS.AREA_PSF_CHANGE],
    currentAreaPsfCount: currentData[STAT_TARGET_KEYS.AREA_PSF_COUNT],
  }
  return {
    currentLabel: label,
    ...currentYearData,
  }
}

const CustomIcon = () => (
  <SvgIcon name="#icon-dropdown-arrow" width={10} height={10} />
)


class SimpleChartsV2 extends Component {
  constructor(props) {
    super(props)

    this.handleOfferChange = this.handleOfferChange.bind(this)
    this.handleSliderAfterChange = this.handleSliderAfterChange.bind(this)
    this.handleChartClick = this.handleChartClick.bind(this)
    this.getChartWrapperRef = this.getChartWrapperRef.bind(this)
    this.handleChartScroll = this.handleChartScroll.bind(this)
    this.initialization = this.initialization.bind(this)

    this.state = {
      offer: 'Sale',
      periodRangeMin: 0,
      periodRangeMax: 0,
      currentPeriodMin: 0,
      currentPeriodMax: 0,
      mergedChartData: null,
      mergedChartDataLookup: null,
      currentBuildingPsf: 0,
      currentBuildingPsfChange: 0,
      currentBuildingPsfCount: 0,
      currentAreaPsf: 0,
      currentAreaPsfChange: 0,
      currentAreaPsfCount: 0,
    }
  }

  componentDidMount() {
    this.initialization()
  }

  componentDidUpdate(prevProps) {
    if(this.props.buildingStats !== prevProps.buildingStats) {
      this.initialization()
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleChartScroll)
  }

  initialization() {
    const initStatData = mergeAreaBuilding(
      'Sale',
      this.props.areaStats,
      this.props.buildingStats,
    )
    const initCurrent = clickedPointUpdated(
      String(initStatData.periodRangeMax),
      initStatData.mergedChartData,
      initStatData.mergedChartDataLookup,
    )
    this.setState({
      currentLabel: String(initStatData.periodRangeMax),
      ...initStatData,
      ...initCurrent,
    })
  }

  getChartWrapperRef(ref) {
    if(!ref) return null
    this.chartElem = ref
    // this.timeout = setTimeout(() => {
    //   this.chartElem.scrollLeft += 1000
    // })
    ref.addEventListener('scroll', this.handleChartScroll)
  }
  handleChartScroll(e) {
    if(!this.chartElem) return null
    if(!this.firstScrollEvent) {
      this.firstScrollEvent = true
      return null
    }
    const { mergedChartData, mergedChartDataLookup, currentLabel } = this.state
    const dataIndex = getDataIndexOnScroll({
      data: mergedChartData,
      target: e.target,
    })
    if(mergedChartData[dataIndex]) {
      const data = mergedChartData[dataIndex]
      if(currentLabel !== data.name) {
        const newState = clickedPointUpdated(
          data.name,
          mergedChartData,
          mergedChartDataLookup,
        )
        this.setState(newState)
      }
    }
  }
  handleChartClick(e) {
    if(e && e.activeLabel) {
      const newCurrentData = clickedPointUpdated(
        e.activeLabel,
        this.state.mergedChartData,
        this.state.mergedChartDataLookup,
      )
      this.setState(newCurrentData)
    }
  }
  handleSliderAfterChange(values) {
    const newCurrentData = clickedPointUpdated(
      String(values[1]),
      this.state.mergedChartData,
      this.state.mergedChartDataLookup,
    )
    this.setState({
      currentPeriodMin: Number(values[0]),
      currentPeriodMax: Number(values[1]),
      ...newCurrentData,
    })
  }

  handleOfferChange(offer) {
    const { source, googleAnalyticsEvent } = this.props
    if(this.props.source) {
      const action = '[ppsf chart offer Click]'
      googleAnalyticsEvent({
        category: source,
        action,
      })
      googleAnalyticsEvent({
        category: source,
        action: `[ppsf chart offer Click][${offer}]`,
      })
    }

    const newMergeData = mergeAreaBuilding(
      offer,
      this.props.areaStats,
      this.props.buildingStats,
    )
    const newCurrentData = clickedPointUpdated(
      String(newMergeData.currentPeriodMax) || this.state.currentLabel,
      newMergeData.mergedChartData,
      newMergeData.mergedChartDataLookup,
    )
    this.setState({
      ...newMergeData,
      ...newCurrentData,
    })
  }

  render() {
    const {
      buildingName,
      areaName,
      mobileBrowser,
      isMobile,
      address,
      printStyle,
      googleAnalyticsEvent,
      source,
      collapsibleIdSuffix,
    } = this.props

    if(!this.props.buildingStats && !this.props.areaStats) return null
    const areaUrl = this.props.areaUrl
      ? this.props.areaUrl +
        `/${PROPERTY_TYPE_PLURAL}-for-${this.state.offer.toLowerCase()}`
      : null
    const {
      offer,
      periodRangeMin,
      periodRangeMax,
      currentPeriodMin,
      currentPeriodMax,
      currentLabel,
      currentBuildingPsf,
      currentBuildingPsfChange,
      currentBuildingPsfCount,
      currentAreaPsf,
      currentAreaPsfChange,
      currentAreaPsfCount,
    } = this.state
    const showMobileVersion = isMobile || mobileBrowser
    const rangeSliderLabel =
      `Compare from ${currentPeriodMin ||
        0} ` +
      `${
        Number(currentPeriodMax) === Number(periodRangeMax)
          ? ''
          : `To ${currentPeriodMax} `
      }`
    const filteredMergeData = []

    let activeTooltipIndex = 0
    this.state.mergedChartData?.forEach(data => {
      if(
        currentPeriodMin <= Number(data.name) &&
        currentPeriodMax >= Number(data.name)
      ) {
        filteredMergeData.push(data)
        if(data.name === currentLabel) {
          activeTooltipIndex = filteredMergeData.length - 1
        }
      }
    })
    const handleLinkClick = () => {
      googleAnalyticsEvent({
        category: source,
        action: '[Chart Click][Neighbourhood]',
      })
    }
    return (
      <Collapsible
        defaultShowState
        inputId={'Historical Avg. Prices' + collapsibleIdSuffix}
        title="Historical Avg. Price/sqft"
        showSeparatorLine={false}
        isCollapsible={source !== 'building'}
        customClasses={{
          collapseLabel: outerCollapseLabelCss,
          collapseContent: printStyle ? printCollapsibleContentCss : simpleChartCollapseContentCss,
        }}
      >
        <_RowContainer>

          {!printStyle && areaUrl && (
            <_AreaOfferContainer>
              <_DesktopVisitButtonContainer>
                {'Neighbourhood: '}
                <_VisitButton
                  openNewTab
                  to={'/' + areaUrl}
                  alt="View Nearby Area"
                  onClick={handleLinkClick}

                >
                  {areaName}
                </_VisitButton>
              </_DesktopVisitButtonContainer>

              {!printStyle &&
                <_OfferContainer>
                  <OfferTabV3
                    handleClick={this.handleOfferChange}
                    layoutId={'simpleCharts'}
                  />
                </_OfferContainer>
              }

              {
                !printStyle && periodRangeMin && periodRangeMax ? (
                  <_RangeSliderPositionContainer>
                    <_RangeSliderContainer>
                      <Collapsible
                        defaultShowState
                        customClasses={{
                          collapseLabel: sliderCollapseLabelCss,
                          collapseContent: sliderCollapseContentCss,
                          collapseInput: sliderCollapseInputCss,
                          contentInner: sliderContentInnerCss,
                        }}
                        CustomIcon={CustomIcon}
                        title={rangeSliderLabel}
                        showSeparatorLine={false}
                        gaActionTitle={'Period Slider'}
                      >
                        <RangeSlider
                          aria-haspopup
                          aria-expanded
                          minVal={currentPeriodMin}
                          maxVal={currentPeriodMax}
                          sliderProps={{
                            min: periodRangeMin,
                            max: periodRangeMax,
                            value: [currentPeriodMin, currentPeriodMax],
                          }}
                          handleSliderAfterChange={this.handleSliderAfterChange}
                          disableInput
                        />
                      </Collapsible>
                    </_RangeSliderContainer>
                  </_RangeSliderPositionContainer>
                ) : null
              }
            </_AreaOfferContainer>
          )}
        </_RowContainer>

        <_ChartWrapper isPrintStyle={printStyle}>
          <AppLineChart
            areaName={areaName}
            buildingName={buildingName}
            mergedChartData={filteredMergeData}
            dataLength={filteredMergeData.length}
            onChartClick={this.handleChartClick}
            // minimize risk of agent hover over old year on print mode
            onMouseMove={(mobileBrowser || printStyle) ? () => {} : this.handleChartClick}
            getChartWrapperRef={this.getChartWrapperRef}
            currentLabel={currentLabel}
            showMobileVersion={showMobileVersion}
            printStyle={printStyle}
            activeTooltipIndex={activeTooltipIndex}
          />
          <_SummaryContainer isPrintStyle={printStyle}>
            {buildingName && (
              <_ChartSummaryBlock
                title={buildingName || (address && address.split(',')[0])}
                value={currentBuildingPsf}
                changePercent={currentBuildingPsfChange}
                count={currentBuildingPsfCount || 0}
                lineColor={TERTIARY_COLOR}
                offer={offer}
                printStyle={printStyle}
              />
            )}
            <_ChartSummaryBlock
              title={areaName || 'Area'}
              value={currentAreaPsf}
              changePercent={currentAreaPsfChange}
              count={currentAreaPsfCount || 0}
              lineColor={BUTTON_HOVER}
              offer={offer}
              printStyle={printStyle}
            />
          </_SummaryContainer>


        </_ChartWrapper>

        <_MobileVisitButtonContainer>
          <_VisitButton
            openNewTab
            to={'/' + areaUrl}
            alt="View Nearby Area"
            onClick={handleLinkClick}
            disableInApp
          >
            View {areaName}
          </_VisitButton>
          <_ChartSeparatorLine className={'area-chart-bottom-separator-line'} />
        </_MobileVisitButtonContainer>
      </Collapsible>
    )
  }
}


SimpleChartsV2.propTypes = {
  areaStats: PropTypes.shape({}),
  buildingStats: PropTypes.shape({
    chart_types: PropTypes.arrayOf(PropTypes.shape({})),
    charts: PropTypes.shape({}),
    data: PropTypes.shape({
      leased: PropTypes.shape({
        Y: PropTypes.shape({}),
      }),
      sold: PropTypes.shape({
        Y: PropTypes.shape({}),
      }),
    }),
  }),
  buildingName: PropTypes.string,
  areaUrl: PropTypes.string,
  areaName: PropTypes.string,
  address: PropTypes.string,
  mobileBrowser: PropTypes.bool,
  isMobile: PropTypes.bool,
  printStyle: PropTypes.bool,
  googleAnalyticsEvent: PropTypes.func,
  source: PropTypes.string,
  collapsibleIdSuffix: PropTypes.string,
}

export default SimpleChartsV2
